import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, ViewChild, ContentChild, NgModule } from '@angular/core';
import { Calendar } from '@fullcalendar/core';
import { CustomRenderingStore } from '@fullcalendar/core/internal';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
const _c0 = ["*"];
const _c1 = ["rootEl"];
const _c2 = a0 => ({
  $implicit: a0
});
function TransportContainerComponent_ng_template_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2, 0);
    i0.ɵɵelementContainer(2, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.elClasses || "")("ngStyle", ctx_r0.elStyle || null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c2, ctx_r0.renderProps));
  }
}
function TransportContainerComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 2, 0);
    i0.ɵɵelementContainer(2, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.elClasses || "")("ngStyle", ctx_r0.elStyle || null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c2, ctx_r0.renderProps));
  }
}
function TransportContainerComponent_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 2, 0);
    i0.ɵɵelementContainer(2, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.elClasses || "")("ngStyle", ctx_r0.elStyle || null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c2, ctx_r0.renderProps));
  }
}
function TransportContainerComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 2, 0);
    i0.ɵɵelementContainer(2, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.elClasses || "")("ngStyle", ctx_r0.elStyle || null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c2, ctx_r0.renderProps));
  }
}
function TransportContainerComponent_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 2, 0);
    i0.ɵɵelementContainer(2, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.elClasses || "")("ngStyle", ctx_r0.elStyle || null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c2, ctx_r0.renderProps));
  }
}
function TransportContainerComponent_ng_template_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 2, 0);
    i0.ɵɵelementContainer(2, 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r0.elClasses || "")("ngStyle", ctx_r0.elStyle || null);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template)("ngTemplateOutletContext", i0.ɵɵpureFunction1(4, _c2, ctx_r0.renderProps));
  }
}
const _c3 = ["dayHeaderContent"];
const _c4 = ["dayCellContent"];
const _c5 = ["weekNumberContent"];
const _c6 = ["nowIndicatorContent"];
const _c7 = ["eventContent"];
const _c8 = ["slotLaneContent"];
const _c9 = ["slotLabelContent"];
const _c10 = ["allDayContent"];
const _c11 = ["moreLinkContent"];
const _c12 = ["noEventsContent"];
const _c13 = ["resourceAreaHeaderContent"];
const _c14 = ["resourceGroupLabelContent"];
const _c15 = ["resourceLabelContent"];
const _c16 = ["resourceLaneContent"];
const _c17 = ["resourceGroupLaneContent"];
function FullCalendarComponent_transport_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "transport-container", 1);
  }
  if (rf & 2) {
    const customRendering_r1 = ctx.$implicit;
    i0.ɵɵproperty("inPlaceOf", customRendering_r1.containerEl)("reportEl", customRendering_r1.reportNewContainerEl)("elTag", customRendering_r1.elTag)("elClasses", customRendering_r1.elClasses)("elStyle", customRendering_r1.elStyle)("elAttrs", customRendering_r1.elAttrs)("template", customRendering_r1.generatorMeta)("renderProps", customRendering_r1.renderProps);
  }
}
const OPTION_IS_DEEP = {
  headerToolbar: true,
  footerToolbar: true,
  events: true,
  eventSources: true,
  resources: true
};
/*
NOTE: keep synced with component
*/
const OPTION_INPUT_NAMES = ['events', 'eventSources', 'resources'];
const hasOwnProperty = Object.prototype.hasOwnProperty;
/*
Really simple clone utility. Only copies plain arrays, objects, and Dates. Transfers everything else as-is.
Wanted to use a third-party lib, but none did exactly this.
*/
function deepCopy(input) {
  if (Array.isArray(input)) {
    return input.map(deepCopy);
  } else if (input instanceof Date) {
    return new Date(input.valueOf());
  } else if (typeof input === 'object' && input) {
    // non-null object
    return mapHash(input, deepCopy);
  } else {
    // everything else (null, function, etc)
    return input;
  }
}
function mapHash(input, func) {
  const output = {};
  for (const key in input) {
    if (hasOwnProperty.call(input, key)) {
      output[key] = func(input[key], key);
    }
  }
  return output;
}

/*
Forked from https://github.com/epoberezkin/fast-deep-equal (also has MIT license)
Needed ESM support or else Angular complains about treeshaking
(https://github.com/fullcalendar/fullcalendar-angular/issues/421)
*/
function deepEqual(a, b) {
  if (a === b) return true;
  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;
    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;) if (!deepEqual(a[i], b[i])) return false;
      return true;
    }
    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;
    for (i = length; i-- !== 0;) if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    for (i = length; i-- !== 0;) {
      var key = keys[i];
      if (!deepEqual(a[key], b[key])) return false;
    }
    return true;
  }
  // true if both NaN, false otherwise
  return a !== a && b !== b;
}
const dummyContainer$1 = typeof document !== 'undefined' ? document.createDocumentFragment() : null;
class OffscreenFragmentComponent {
  constructor(element) {
    this.element = element;
  }
  ngAfterViewInit() {
    if (dummyContainer$1) {
      dummyContainer$1.appendChild(this.element.nativeElement);
    }
  }
  // invoked BEFORE component removed from DOM
  ngOnDestroy() {
    if (dummyContainer$1) {
      dummyContainer$1.removeChild(this.element.nativeElement);
    }
  }
}
OffscreenFragmentComponent.ɵfac = function OffscreenFragmentComponent_Factory(__ngFactoryType__) {
  return new (__ngFactoryType__ || OffscreenFragmentComponent)(i0.ɵɵdirectiveInject(i0.ElementRef));
};
OffscreenFragmentComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: OffscreenFragmentComponent,
  selectors: [["offscreen-fragment"]],
  standalone: false,
  ngContentSelectors: _c0,
  decls: 1,
  vars: 0,
  template: function OffscreenFragmentComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵprojectionDef();
      i0.ɵɵprojection(0);
    }
  },
  encapsulation: 2
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(OffscreenFragmentComponent, [{
    type: Component,
    args: [{
      selector: 'offscreen-fragment',
      template: '<ng-content></ng-content>',
      encapsulation: ViewEncapsulation.None
    }]
  }], function () {
    return [{
      type: i0.ElementRef
    }];
  }, null);
})();
const dummyContainer = typeof document !== 'undefined' ? document.createDocumentFragment() : null;
class TransportContainerComponent {
  ngAfterViewInit() {
    const rootEl = this.rootElRef?.nativeElement; // assumed defined
    replaceEl(rootEl, this.inPlaceOf);
    applyElAttrs(rootEl, undefined, this.elAttrs);
    // insurance for if Preact recreates and reroots inPlaceOf element
    this.inPlaceOf.style.display = 'none';
    this.reportEl(rootEl);
  }
  ngOnChanges(changes) {
    const rootEl = this.rootElRef?.nativeElement;
    // ngOnChanges is called before ngAfterViewInit (and before DOM initializes)
    // so make sure rootEl is defined before doing anything
    if (rootEl) {
      // If the ContentContainer's tagName changed, it will create a new DOM element in its
      // original place. Detect this and re-replace.
      if (this.inPlaceOf.parentNode !== dummyContainer) {
        replaceEl(rootEl, this.inPlaceOf);
        applyElAttrs(rootEl, undefined, this.elAttrs);
        this.reportEl(rootEl);
      } else {
        const elAttrsChange = changes['elAttrs'];
        if (elAttrsChange) {
          applyElAttrs(rootEl, elAttrsChange.previousValue, elAttrsChange.currentValue);
        }
      }
    }
  }
  // invoked BEFORE component removed from DOM
  ngOnDestroy() {
    if (
    // protect against Preact recreating and rerooting inPlaceOf element
    this.inPlaceOf.parentNode === dummyContainer && dummyContainer) {
      dummyContainer.removeChild(this.inPlaceOf);
    }
    this.reportEl(null);
  }
}
TransportContainerComponent.ɵfac = function TransportContainerComponent_Factory(__ngFactoryType__) {
  return new (__ngFactoryType__ || TransportContainerComponent)();
};
TransportContainerComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: TransportContainerComponent,
  selectors: [["transport-container"]],
  viewQuery: function TransportContainerComponent_Query(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵviewQuery(_c1, 5);
    }
    if (rf & 2) {
      let _t;
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.rootElRef = _t.first);
    }
  },
  inputs: {
    inPlaceOf: "inPlaceOf",
    reportEl: "reportEl",
    elTag: "elTag",
    elClasses: "elClasses",
    elStyle: "elStyle",
    elAttrs: "elAttrs",
    template: "template",
    renderProps: "renderProps"
  },
  standalone: false,
  features: [i0.ɵɵNgOnChangesFeature],
  decls: 6,
  vars: 6,
  consts: [["rootEl", ""], [3, "ngIf"], [3, "ngClass", "ngStyle"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]],
  template: function TransportContainerComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵtemplate(0, TransportContainerComponent_ng_template_0_Template, 3, 6, "ng-template", 1)(1, TransportContainerComponent_ng_template_1_Template, 3, 6, "ng-template", 1)(2, TransportContainerComponent_ng_template_2_Template, 3, 6, "ng-template", 1)(3, TransportContainerComponent_ng_template_3_Template, 3, 6, "ng-template", 1)(4, TransportContainerComponent_ng_template_4_Template, 3, 6, "ng-template", 1)(5, TransportContainerComponent_ng_template_5_Template, 3, 6, "ng-template", 1);
    }
    if (rf & 2) {
      i0.ɵɵproperty("ngIf", ctx.elTag == "div");
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.elTag == "span");
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.elTag == "a");
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.elTag == "tr");
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.elTag == "th");
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngIf", ctx.elTag == "td");
    }
  },
  dependencies: [i1.NgIf, i1.NgClass, i1.NgStyle, i1.NgTemplateOutlet],
  encapsulation: 2
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(TransportContainerComponent, [{
    type: Component,
    args: [{
      selector: 'transport-container',
      encapsulation: ViewEncapsulation.None,
      template: "<ng-template [ngIf]=\"elTag == 'div'\">\n  <div #rootEl [ngClass]=\"elClasses || ''\" [ngStyle]=\"elStyle || null\">\n    <ng-container\n      [ngTemplateOutlet]=\"template\"\n      [ngTemplateOutletContext]=\"{ $implicit: renderProps }\"\n    ></ng-container>\n  </div>\n</ng-template>\n<ng-template [ngIf]=\"elTag == 'span'\">\n  <span #rootEl [ngClass]=\"elClasses || ''\" [ngStyle]=\"elStyle || null\">\n    <ng-container\n      [ngTemplateOutlet]=\"template\"\n      [ngTemplateOutletContext]=\"{ $implicit: renderProps }\"\n    ></ng-container>\n  </span>\n</ng-template>\n<ng-template [ngIf]=\"elTag == 'a'\">\n  <a #rootEl [ngClass]=\"elClasses || ''\" [ngStyle]=\"elStyle || null\">\n    <ng-container\n      [ngTemplateOutlet]=\"template\"\n      [ngTemplateOutletContext]=\"{ $implicit: renderProps }\"\n    ></ng-container>\n  </a>\n</ng-template>\n<ng-template [ngIf]=\"elTag == 'tr'\">\n  <tr #rootEl [ngClass]=\"elClasses || ''\" [ngStyle]=\"elStyle || null\">\n    <ng-container\n      [ngTemplateOutlet]=\"template\"\n      [ngTemplateOutletContext]=\"{ $implicit: renderProps }\"\n    ></ng-container>\n  </tr>\n</ng-template>\n<ng-template [ngIf]=\"elTag == 'th'\">\n  <th #rootEl [ngClass]=\"elClasses || ''\" [ngStyle]=\"elStyle || null\">\n    <ng-container\n      [ngTemplateOutlet]=\"template\"\n      [ngTemplateOutletContext]=\"{ $implicit: renderProps }\"\n    ></ng-container>\n  </th>\n</ng-template>\n<ng-template [ngIf]=\"elTag == 'td'\">\n  <td #rootEl [ngClass]=\"elClasses || ''\" [ngStyle]=\"elStyle || null\">\n    <ng-container\n      [ngTemplateOutlet]=\"template\"\n      [ngTemplateOutletContext]=\"{ $implicit: renderProps }\"\n    ></ng-container>\n  </td>\n</ng-template>\n"
    }]
  }], null, {
    inPlaceOf: [{
      type: Input
    }],
    reportEl: [{
      type: Input
    }],
    elTag: [{
      type: Input
    }],
    elClasses: [{
      type: Input
    }],
    elStyle: [{
      type: Input
    }],
    elAttrs: [{
      type: Input
    }],
    template: [{
      type: Input
    }],
    renderProps: [{
      type: Input
    }],
    rootElRef: [{
      type: ViewChild,
      args: ['rootEl']
    }]
  });
})();
function replaceEl(subject, inPlaceOf) {
  inPlaceOf.parentNode?.insertBefore(subject, inPlaceOf.nextSibling);
  if (dummyContainer) {
    dummyContainer.appendChild(inPlaceOf);
  }
}
function applyElAttrs(el, previousAttrs = {}, currentAttrs = {}) {
  // these are called "attributes" but they manipulate DOM node *properties*
  for (const attrName in previousAttrs) {
    if (!(attrName in currentAttrs)) {
      el[attrName] = null;
    }
  }
  for (const attrName in currentAttrs) {
    el[attrName] = currentAttrs[attrName];
  }
}
class FullCalendarComponent {
  constructor(element, changeDetector) {
    this.element = element;
    this.calendar = null;
    this.optionSnapshot = {}; // for diffing
    this.customRenderingMap = new Map();
    const customRenderingStore = new CustomRenderingStore();
    customRenderingStore.subscribe(customRenderingMap => {
      this.customRenderingMap = customRenderingMap;
      this.customRenderingArray = undefined; // clear cache
      changeDetector.detectChanges();
    });
    this.handleCustomRendering = customRenderingStore.handle.bind(customRenderingStore);
  }
  ngAfterViewInit() {
    const {
      deepChangeDetection
    } = this;
    const options = {
      ...this.options,
      ...this.buildInputOptions()
    };
    // initialize snapshot
    this.optionSnapshot = mapHash(options, (optionVal, optionName) => deepChangeDetection && OPTION_IS_DEEP[optionName] ? deepCopy(optionVal) : optionVal);
    const calendarEl = this.element.nativeElement;
    const calendar = this.calendar = new Calendar(calendarEl, {
      ...options,
      ...this.buildExtraOptions()
    });
    // Ionic dimensions hack
    // https://github.com/fullcalendar/fullcalendar/issues/4976
    const ionContent = calendarEl.closest('ion-content');
    if (ionContent && ionContent.componentOnReady) {
      ionContent.componentOnReady().then(() => {
        window.requestAnimationFrame(() => {
          calendar.render();
        });
      });
    } else {
      calendar.render();
    }
    // Angular v19, whether because of new Vite dev environment or not,
    // loads outer elements' styles late, so dimensions might not be final here.
    // Force a size-update after a delay.
    setTimeout(() => calendar.updateSize());
  }
  /*
  allows us to manually detect complex input changes, internal mutations to certain options.
  called before ngOnChanges. called much more often than ngOnChanges.
  */
  ngDoCheck() {
    if (this.calendar) {
      // not the initial render
      const {
        deepChangeDetection,
        optionSnapshot
      } = this;
      const newOptions = {
        ...this.options,
        ...this.buildInputOptions()
      };
      const newProcessedOptions = {};
      const changedOptionNames = [];
      // detect adds and updates (and update snapshot)
      for (const optionName in newOptions) {
        if (newOptions.hasOwnProperty(optionName)) {
          let optionVal = newOptions[optionName];
          if (deepChangeDetection && OPTION_IS_DEEP[optionName]) {
            if (!deepEqual(optionSnapshot[optionName], optionVal)) {
              optionSnapshot[optionName] = deepCopy(optionVal);
              changedOptionNames.push(optionName);
            }
          } else {
            if (optionSnapshot[optionName] !== optionVal) {
              optionSnapshot[optionName] = optionVal;
              changedOptionNames.push(optionName);
            }
          }
          newProcessedOptions[optionName] = optionVal;
        }
      }
      const oldOptionNames = Object.keys(optionSnapshot);
      // detect removals (and update snapshot)
      for (const optionName of oldOptionNames) {
        if (!(optionName in newOptions)) {
          // doesn't exist in new options?
          delete optionSnapshot[optionName];
          changedOptionNames.push(optionName);
        }
      }
      if (changedOptionNames.length) {
        this.calendar.pauseRendering();
        this.calendar.resetOptions({
          ...newProcessedOptions,
          ...this.buildExtraOptions()
        }, changedOptionNames);
      }
    }
  }
  ngAfterContentChecked() {
    if (this.calendar) {
      // too defensive?
      this.calendar.resumeRendering();
    }
  }
  ngOnDestroy() {
    if (this.calendar) {
      // too defensive?
      this.calendar.destroy();
      this.calendar = null;
    }
  }
  get customRenderings() {
    return this.customRenderingArray || (this.customRenderingArray = [...this.customRenderingMap.values()]);
  }
  getApi() {
    return this.calendar;
  }
  buildInputOptions() {
    const options = {};
    for (const inputName of OPTION_INPUT_NAMES) {
      const inputValue = this[inputName];
      if (inputValue != null) {
        // exclude both null and undefined
        options[inputName] = inputValue;
      }
    }
    return options;
  }
  buildExtraOptions() {
    return {
      handleCustomRendering: this.handleCustomRendering,
      customRenderingMetaMap: this,
      customRenderingReplaces: true
    };
  }
  // for `trackBy` in loop
  trackCustomRendering(index, customRendering) {
    return customRendering.id;
  }
}
FullCalendarComponent.ɵfac = function FullCalendarComponent_Factory(__ngFactoryType__) {
  return new (__ngFactoryType__ || FullCalendarComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef));
};
FullCalendarComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
  type: FullCalendarComponent,
  selectors: [["full-calendar"]],
  contentQueries: function FullCalendarComponent_ContentQueries(rf, ctx, dirIndex) {
    if (rf & 1) {
      i0.ɵɵcontentQuery(dirIndex, _c3, 7);
      i0.ɵɵcontentQuery(dirIndex, _c4, 7);
      i0.ɵɵcontentQuery(dirIndex, _c5, 7);
      i0.ɵɵcontentQuery(dirIndex, _c6, 7);
      i0.ɵɵcontentQuery(dirIndex, _c7, 7);
      i0.ɵɵcontentQuery(dirIndex, _c8, 7);
      i0.ɵɵcontentQuery(dirIndex, _c9, 7);
      i0.ɵɵcontentQuery(dirIndex, _c10, 7);
      i0.ɵɵcontentQuery(dirIndex, _c11, 7);
      i0.ɵɵcontentQuery(dirIndex, _c12, 7);
      i0.ɵɵcontentQuery(dirIndex, _c13, 7);
      i0.ɵɵcontentQuery(dirIndex, _c14, 7);
      i0.ɵɵcontentQuery(dirIndex, _c15, 7);
      i0.ɵɵcontentQuery(dirIndex, _c16, 7);
      i0.ɵɵcontentQuery(dirIndex, _c17, 7);
    }
    if (rf & 2) {
      let _t;
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dayHeaderContent = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.dayCellContent = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.weekNumberContent = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.nowIndicatorContent = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.eventContent = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.slotLaneContent = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.slotLabelContent = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.allDayContent = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.moreLinkContent = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.noEventsContent = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resourceAreaHeaderContent = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resourceGroupLabelContent = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resourceLabelContent = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resourceLaneContent = _t.first);
      i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resourceGroupLaneContent = _t.first);
    }
  },
  inputs: {
    options: "options",
    deepChangeDetection: "deepChangeDetection",
    events: "events",
    eventSources: "eventSources",
    resources: "resources"
  },
  standalone: false,
  decls: 2,
  vars: 2,
  consts: [[3, "inPlaceOf", "reportEl", "elTag", "elClasses", "elStyle", "elAttrs", "template", "renderProps", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "inPlaceOf", "reportEl", "elTag", "elClasses", "elStyle", "elAttrs", "template", "renderProps"]],
  template: function FullCalendarComponent_Template(rf, ctx) {
    if (rf & 1) {
      i0.ɵɵelementStart(0, "offscreen-fragment");
      i0.ɵɵtemplate(1, FullCalendarComponent_transport_container_1_Template, 1, 8, "transport-container", 0);
      i0.ɵɵelementEnd();
    }
    if (rf & 2) {
      i0.ɵɵadvance();
      i0.ɵɵproperty("ngForOf", ctx.customRenderings)("ngForTrackBy", ctx.trackCustomRendering);
    }
  },
  dependencies: [OffscreenFragmentComponent, TransportContainerComponent, i1.NgForOf],
  encapsulation: 2
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FullCalendarComponent, [{
    type: Component,
    args: [{
      selector: 'full-calendar',
      encapsulation: ViewEncapsulation.None // the styles are root-level, not scoped within the component
      ,
      template: "<offscreen-fragment>\n  <transport-container *ngFor=\"let customRendering of customRenderings; trackBy:trackCustomRendering\"\n    [inPlaceOf]=\"customRendering.containerEl\"\n    [reportEl]=\"customRendering.reportNewContainerEl\"\n    [elTag]=\"customRendering.elTag\"\n    [elClasses]=\"customRendering.elClasses\"\n    [elStyle]=\"customRendering.elStyle\"\n    [elAttrs]=\"customRendering.elAttrs\"\n    [template]=\"customRendering.generatorMeta\"\n    [renderProps]=\"customRendering.renderProps\"\n  ></transport-container>\n</offscreen-fragment>\n"
    }]
  }], function () {
    return [{
      type: i0.ElementRef
    }, {
      type: i0.ChangeDetectorRef
    }];
  }, {
    options: [{
      type: Input
    }],
    deepChangeDetection: [{
      type: Input
    }],
    events: [{
      type: Input
    }],
    eventSources: [{
      type: Input
    }],
    resources: [{
      type: Input
    }],
    dayHeaderContent: [{
      type: ContentChild,
      args: ['dayHeaderContent', {
        static: true
      }]
    }],
    dayCellContent: [{
      type: ContentChild,
      args: ['dayCellContent', {
        static: true
      }]
    }],
    weekNumberContent: [{
      type: ContentChild,
      args: ['weekNumberContent', {
        static: true
      }]
    }],
    nowIndicatorContent: [{
      type: ContentChild,
      args: ['nowIndicatorContent', {
        static: true
      }]
    }],
    eventContent: [{
      type: ContentChild,
      args: ['eventContent', {
        static: true
      }]
    }],
    slotLaneContent: [{
      type: ContentChild,
      args: ['slotLaneContent', {
        static: true
      }]
    }],
    slotLabelContent: [{
      type: ContentChild,
      args: ['slotLabelContent', {
        static: true
      }]
    }],
    allDayContent: [{
      type: ContentChild,
      args: ['allDayContent', {
        static: true
      }]
    }],
    moreLinkContent: [{
      type: ContentChild,
      args: ['moreLinkContent', {
        static: true
      }]
    }],
    noEventsContent: [{
      type: ContentChild,
      args: ['noEventsContent', {
        static: true
      }]
    }],
    resourceAreaHeaderContent: [{
      type: ContentChild,
      args: ['resourceAreaHeaderContent', {
        static: true
      }]
    }],
    resourceGroupLabelContent: [{
      type: ContentChild,
      args: ['resourceGroupLabelContent', {
        static: true
      }]
    }],
    resourceLabelContent: [{
      type: ContentChild,
      args: ['resourceLabelContent', {
        static: true
      }]
    }],
    resourceLaneContent: [{
      type: ContentChild,
      args: ['resourceLaneContent', {
        static: true
      }]
    }],
    resourceGroupLaneContent: [{
      type: ContentChild,
      args: ['resourceGroupLaneContent', {
        static: true
      }]
    }]
  });
})();
class FullCalendarModule {}
FullCalendarModule.ɵfac = function FullCalendarModule_Factory(__ngFactoryType__) {
  return new (__ngFactoryType__ || FullCalendarModule)();
};
FullCalendarModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
  type: FullCalendarModule,
  declarations: [FullCalendarComponent, OffscreenFragmentComponent, TransportContainerComponent],
  imports: [CommonModule],
  exports: [FullCalendarComponent]
});
FullCalendarModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
  imports: [[CommonModule]]
});
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(FullCalendarModule, [{
    type: NgModule,
    args: [{
      declarations: [FullCalendarComponent, OffscreenFragmentComponent, TransportContainerComponent],
      imports: [CommonModule],
      exports: [FullCalendarComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { FullCalendarComponent, FullCalendarModule };
